var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHappy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    focusable: "false",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 0C15.5142 0 20 4.48583 20 10C20 15.5142 15.5142 20 10 20C4.48583 20 0 15.5142 0 10C0 4.48583 4.48583 0 10 0ZM10 18.3333C14.595 18.3333 18.3333 14.595 18.3333 10C18.3333 5.405 14.595 1.66667 10 1.66667C5.405 1.66667 1.66667 5.405 1.66667 10C1.66667 14.595 5.405 18.3333 10 18.3333ZM6.54667 11.2358C7.33917 12.5492 8.63 13.3333 10 13.3333C11.37 13.3333 12.6608 12.5492 13.4533 11.2358L14.88 12.0975C13.7842 13.915 11.96 15 10 15C8.04 15 6.21583 13.915 5.12 12.0975L6.54667 11.2358ZM6.66667 9.16667C7.58667 9.16667 8.33333 8.42 8.33333 7.5C8.33333 6.58 7.58667 5.83333 6.66667 5.83333C5.74667 5.83333 5 6.58 5 7.5C5 8.42 5.74667 9.16667 6.66667 9.16667ZM11.6667 7.5C11.6667 6.58 12.4133 5.83333 13.3333 5.83333C14.2533 5.83333 15 6.58 15 7.5C15 8.42 14.2533 9.16667 13.3333 9.16667C12.4133 9.16667 11.6667 8.42 11.6667 7.5Z",
    fill: "#DC1928"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHappy);
export default __webpack_public_path__ + "static/media/happy.45ae179c99fec9ab4eb70c1e33acbc4e.svg";
export { ForwardRef as ReactComponent };